export default {
  cartonNumber: '箱号',
  scanDate: '扫描时间',
  tunnelID: '通道机编号',
  filter: 'Filter',
  rfid: 'EPC',
  productCode: '产品编号',
  size: 'Size',
  upc: 'UPC',
  productName: '产品名称',
  purchaseOrder: '采购订单号',
  salesOrder: '销售订单号',
  IB: 'IB',
  IBTitle: 'IB ',
  IBCartonNumber: '箱号',
  IBOriginalCartonNumber: '原箱号',
  IBASN: 'ASN',
  IBTunnelID: '通道机编号',
  IBLPNSizeType: '物流包装单元尺寸类型',
  IBFactoryCode: '工厂代码',
  IBCarrier: '承运商',
  IBItemAttribute: '物品属性',
  IBGRDate: 'GR 时间',
  IBScanDate: '扫描时间',
  OB: 'OB',
  OBTitle: 'OB ',
  OBCartonNumber: '箱号',
  OBDeliveryNoteNo: '送货单号',
  OBMajor: 'Major',
  OBTunnelID: '通道机编号',
  OBTaskType: 'Task Type',
  OBSOType: 'SO 类型',
  OBCarrier: '承运商',
  OBRetag: 'Retag',
  OBShipFrom: '发货地',
  OBShipTo: '收货地',
  OBStore: '门店',
  OBItemAttribute: '物品属性',
  OBTrailerNumber: '承运车牌号',
  OBCartonNetWeight: 'Carton Net Weight',
  OBCartonGrossWeight: 'Carton Gross Weight',
  OBGIDate: 'GI 时间',
  OBScanDate: '扫描时间',
  deliveryNo: '送货单号',
  cartonNo: '箱号',
  qty: '数量',
  shipfrom: '发货地',
  shipto: '收货地',
  store: '门店',
  retag: '补标',
  createDate: '创建时间',
  updateDate: '更新时间',
  downloadLifecycle: '导出生命周期明细',
  rfidHistory: 'RFID历史',
  operation: '操作',
  operator: '操作人',
  rso: 'RSO',
  returnValidation: '退货验证',
  originalCartonNumber: '原始箱号'
}
